/*** IMPORTS FROM imports-loader ***/
var define = false;

import be_uri from './config.js'
import Glide from 'glide.esm'
import countdown from 'countdown.min'
import {gsap} from "gsap";
import axios from "axios";
import BSN from "bootstrap.native";
//import {ScrollTrigger} from "gsap/ScrollTrigger";
//import {ScrollToPlugin} from "gsap/ScrollToPlugin";
import LazyLoad from 'vanilla-lazyload/dist/lazyload.min'

gsap.registerPlugin(LazyLoad);

let imagesLoaded = require('imagesloaded');
const navbar = document.querySelector('.navbar');

function isInViewport(element) {
    const rect = element.getBoundingClientRect();
    //console.log(rect);
    return (
        rect.top >= 0 - element.getBoundingClientRect().height &&
        rect.bottom <= element.getBoundingClientRect().height + (window.innerHeight || document.documentElement.clientHeight)
    );
}

(function () {
    "use strict";
    console.log('JS loaded');

    document.querySelectorAll(".glide-matches.home").forEach((elem) => {
        console.log('init glide-matches.home' + elem.dataset.mid + ' Refresh every ' + elem.dataset.refresh + 'min');
        let kid = elem.dataset.kid;
        let timer = setInterval(function () {
            // Make a request for a user with a given ID
            loadMatches(kid, elem);
        }, 1000 * 60 * elem.dataset.refresh)
        loadMatches(kid, elem);

    });

    function loadMatches(kid, elem) {
        axios.get(be_uri + 'turnier/result/' + kid)
//        axios.get('http://nk4_api.btqa.de:8000/api/v1/turnier/result/' + kid)
            .then(function (response) {
                // handle success
                console.log('update matches ' + kid);


                console.log(response.data.matches);
                let slides = elem.querySelector('.glide__slides')
                $(slides).html('')
                let jump = null
                let i = null
                response.data.matches.forEach(($match) => {
                    console.log($match)
                    let $flag = ''
                    let $color
                    let $p1avatarUrl = '/resources/icons/avatar.svg';
                    let $p2avatarUrl = '/resources/icons/avatar.svg';
                    //console.log(match.value.is_mainround)
                    if ($match['player_1'] && $match['player_1']['avatar']) {
                        $p1avatarUrl = $match['player_1']['avatar'] !== '{}' ? JSON.parse($match['player_1']['avatar']).url : '/resources/icons/avatar.svg';
                    }

                    if ($match['player_2'] && $match['player_2']['avatar']) {
                        $p2avatarUrl = $match['player_2']['avatar'] !== '{}' ? JSON.parse($match['player_2']['avatar']).url : '/resources/icons/avatar.svg';
                    }
                    if ($match['match_winner']) {
                        $color = 'winner';
                        $flag = 'ENDED'

                    } else if ($match['sets'] && $match['sets'].length > 0) {
                        $color = 'running';
                        $flag = 'LIVE'
                        if (!jump)
                            jump = i
                    }

                    let $matchClass = !$match['is_mainround'] ? 'nebenrunde ' + $color : $color;
                    let $p1name2 = '';
                    let $p2name2 = '';
                    if ($match['player_1'])
                        $p1name2 = $match['player_1']['firstname'] + ' ' + $match['player_1']['name'].substr(0, 1) + '.';
                    if ($match['player_2'])
                        $p2name2 = $match['player_2']['firstname'] + ' ' + $match['player_2']['name'].substr(0, 1) + '.';
                    //matchClass.value = $match['player_1'] === '' && $match['player_1'] === '' ? 'disabled' : ''

                    let $p1Class = '';
                    let $p2Class = '';
                    if ($match['player_1'])
                        $p1Class = $match['match_winner'] === $match['player_1']['player_id'] ? 'text-positive' : '';
                    if ($match['player_2'])
                        $p2Class = $match['match_winner'] === $match['player_2']['player_id'] ? 'text-positive' : '';

                    let $p1sets = '';
                    let $p2sets = '';

                    $match.sets.forEach(($set) => {

                        let $class = $set['p1_points'] > $set['p2_points'] ? 'positive' : '';
                        let $class2 = $set['p2_points'] > $set['p1_points'] ? 'positive' : '';
                        $p1sets += '<span class="' + $class + '">' + $set['p1_points'] + '</span>';
                        $p2sets += '<span class="' + $class2 + '">' + $set['p2_points'] + '</span>';
                    })
                    let $round = '';
                    if ($match.type === 16) {
                        if ($match.round === 1) $round = 'Vorrunde'
                        if ($match.round === 2) $round = 'Viertelfinale'
                        if ($match.round === 3) $round = 'Halbfinale'
                        if ($match.round === 4) $round = 'Finale'
                    } else if ($match.type === 8) {
                        if ($match.round === 1) $round = 'Vorrunde'
                        if ($match.round === 2) $round = 'Halbfinale'
                        if ($match.round === 3) $round = 'Finale'
                    } else if ($match.type === 32) {
                        if ($match.round === 1) $round = 'Vorrunde'
                        if ($match.round === 2) $round = 'Achtelfinale'
                        if ($match.round === 3) $round = 'Viertelfinale'
                        if ($match.round === 4) $round = 'Halbfinale'
                        if ($match.round === 5) $round = 'Finale'
                    }

                    if (!$match.is_mainround)
                        $round = "NR " + $round;

                    if (!$match.is_freegame) {

                        let el = $('<li class="glide__slide"><div class="match ' + $matchClass + '">\n' +
                            '            <div class="game">' + $round + ' - Spiel ' + $match['match_number'] + '</div>\n' +
                            '            <div class="players">\n' +
                            '                <div class="player ' + $p1Class + '">\n' +
                            '                    <div class="name">\n' +
                            '                    <span class="q-icon icon-small round" aria-hidden="true" role="presentation">\n' +
                            '                    <img src="' + $p1avatarUrl + '"></span> ' + $p1name2 + '\n' +
                            '                    </div>\n' +
                            '                    <div class="points">\n' +
                            '                        ' + $p1sets + '\n' +
                            '                    </div>\n' +
                            '                </div>\n' +
                            '                <span class="q-icon icon-small vs" aria-hidden="true" role="presentation"><img src="/resources/icons/vs.svg"></span>\n' +
                            '                <div class="player ' + $p2Class + '">\n' +
                            '                    <div class="name">\n' +
                            '                    <span class="q-icon icon-small round" aria-hidden="true" role="presentation">\n' +
                            '                    <img src="' + $p2avatarUrl + '"></span> ' + $p2name2 + '\n' +
                            '                    </div>\n' +
                            '                    <div class="points">\n' +
                            '                        ' + $p2sets + '\n' +
                            '                    </div>\n' +
                            '                </div>\n' +
                            '            </div>\n' +
                            '        </div><div class="flag ' + $color + '">' + $flag + '</div></li>')
                        $(slides).append(el)
                        i++
                    }

                })

                let j = 0
                if (jump)
                    j = jump
                new Glide(elem, {
                    autoplay: 0,
                    startAt: j,
                    type: 'slider',
                    perView: 3,
                    bound: true,
                    breakpoints: {
                        767: {
                            perView: 2
                        },
                        600: {
                            perView: 1
                        }
                    },
                    rewind: false
                }).mount()


            })
            .catch(function (error) {
                // handle error
                console.log(error);
            })
            .finally(function () {
                // always executed
            });
    }

    document.querySelectorAll(".glide-matches.masters").forEach((elem) => {
        console.log('init glide-matches-masters ' + elem.dataset.mid + ' Refresh every ' + elem.dataset.refresh + 'min');
        let kid = elem.dataset.kid;
        let timer = setInterval(function () {
            // Make a request for a user with a given ID
            loadMatchesMasters(kid, elem);
        }, 1000 * 60 * elem.dataset.refresh)
        loadMatchesMasters(kid, elem);
    });

    function loadMatchesMasters(kid, elem) {
      axios.get(be_uri + 'turnier/result/' + kid)
//      axios.get('http://si-23072-nk4.dkr:8000/api/v1/turnier/result/' + kid)
//        axios.get('https://api.nk-4.com/api/v1/turnier/result/' + kid)
//        axios.get('http://nk4_api.btqa.de:8000/api/v1/turnier/result/' + kid)
            .then(function (response) {
                // handle success
                console.log('update matches ' + kid);


                //console.log(response.data.matches);
                let slides = elem.querySelector('.glide__slides')
                $(slides).html('')
                let jump = null
                let i = 0
                response.data.matches.forEach(($match) => {
                    //console.log($match)
                    let $flag = ''
                    let $color
                    let $p1avatarUrl = '/resources/icons/avatar.svg';
                    let $p2avatarUrl = '/resources/icons/avatar.svg';
                    //console.log(match.value.is_mainround)
                    if ($match['player_1'] && $match['player_1']['avatar']) {
                        $p1avatarUrl = $match['player_1']['avatar'] !== '{}' ? JSON.parse($match['player_1']['avatar']).url : '/resources/icons/avatar.svg';
                    }

                    if ($match['player_2'] && $match['player_2']['avatar']) {
                        $p2avatarUrl = $match['player_2']['avatar'] !== '{}' ? JSON.parse($match['player_2']['avatar']).url : '/resources/icons/avatar.svg';
                    }
                    if ($match['match_winner']) {
                        $color = 'winner';
                        $flag = 'ENDED'

                    } else if ($match['sets'] && $match['sets'].length > 0) {
                        $color = 'running';
                        $flag = ''
                        if (!jump)
                            jump = i
                    }

                    let $matchClass = !$match['is_mainround'] ? 'nebenrunde ' + $color : $color;
                    let $p1name2 = '';
                    let $p2name2 = '';
                    if ($match['player_1'])
                        $p1name2 = $match['player_1']['firstname'] + ' ' + $match['player_1']['name'].substr(0, 1) + '.';
                    if ($match['player_2'])
                        $p2name2 = $match['player_2']['firstname'] + ' ' + $match['player_2']['name'].substr(0, 1) + '.';
                    //matchClass.value = $match['player_1'] === '' && $match['player_1'] === '' ? 'disabled' : ''

                    let $p1Class = '';
                    let $p2Class = '';
                    if ($match['player_1'])
                        $p1Class = $match['match_winner'] === $match['player_1']['player_id'] ? 'text-positive' : '';
                    if ($match['player_2'])
                        $p2Class = $match['match_winner'] === $match['player_2']['player_id'] ? 'text-positive' : '';

                    let $p1sets = '';
                    let $p2sets = '';

                    $match.sets.forEach(($set) => {

                        let $class = $set['p1_points'] > $set['p2_points'] ? 'positive' : '';
                        let $class2 = $set['p2_points'] > $set['p1_points'] ? 'positive' : '';
                        $p1sets += '<span class="' + $class + '">' + $set['p1_points'] + '</span>';
                        $p2sets += '<span class="' + $class2 + '">' + $set['p2_points'] + '</span>';
                    })
                    let $round = '';

                        if ($match.round === 1) $round = 'Gruppenrunde'
                        if ($match.round === 2) $round = 'Halbfinale'
                        if ($match.round === 3) $round = 'Finale'


                    if (!$match.is_freegame && !$match['match_winner'] && $match['sets'] && $match['sets'].length > 0) {

                        let el = $('<li class="glide__slide"><div class="match ' + $matchClass + '">\n' +
                            '            <div class="game">' + $round + ' - Spiel ' + $match['match_number'] + '</div>\n' +
                            '            <div class="players">\n' +
                            '                <div class="player ' + $p1Class + '">\n' +
                            '                    <div class="name">\n' +
                            '                    <span class="q-icon icon-small round" aria-hidden="true" role="presentation">\n' +
                            '                    <img src="' + $p1avatarUrl + '"></span> ' + $p1name2 + '\n' +
                            '                    </div>\n' +
                            '                    <div class="points">\n' +
                            '                        ' + $p1sets + '\n' +
                            '                    </div>\n' +
                            '                </div>\n' +
                            '                <span class="q-icon icon-small vs" aria-hidden="true" role="presentation"><img src="/resources/icons/vs.svg"></span>\n' +
                            '                <div class="player ' + $p2Class + '">\n' +
                            '                    <div class="name">\n' +
                            '                    <span class="q-icon icon-small round" aria-hidden="true" role="presentation">\n' +
                            '                    <img src="' + $p2avatarUrl + '"></span> ' + $p2name2 + '\n' +
                            '                    </div>\n' +
                            '                    <div class="points">\n' +
                            '                        ' + $p2sets + '\n' +
                            '                    </div>\n' +
                            '                </div>\n' +
                            '            </div>\n' +
                            '        </div><div class="flag ' + $color + '">' + $flag + '</div></li>')
                        $(slides).append(el)
                        i++
                    }

                })

                let j = 0
                if (jump !== null) {
                    j = jump
                    elem.parentElement.parentElement.classList.remove('hidden')
                }else
                    elem.parentElement.parentElement.classList.add('hidden')

                new Glide(elem, {
                    autoplay: 5000,
                    startAt: j,
                    type: 'slider',
                    perView: 1,
                    bound: true,
                    breakpoints: {
                        767: {
                            perView: 1
                        },
                        600: {
                            perView: 1
                        }
                    }
                }).mount()


            })
            .catch(function (error) {
                // handle error
                console.log(error);
            })
            .finally(function () {
                // always executed
            });
    }


    document.querySelectorAll(".accordion").forEach((accordion) => {
        var myAccordion = accordion;

// grab the collapse elements of this accordion
        var myAccordionCollapses = myAccordion.querySelectorAll('.collapse');

// initialize the component for each collapse trigger
        Array.from(myAccordionCollapses).forEach((collapse) =>
            new BSN.Collapse(
                collapse,
                {
                    parent: myAccordion
                }
            )
        )
    });


    // Mobile toggler
    document.querySelectorAll("button.navbar-toggler")[0].addEventListener("click", function (event) {
        let target = document.querySelectorAll('.navbar-collapse')[0];
        if (!this.classList.contains('open')) {
            $(this).addClass('open');
            $(target).addClass('show');
            $(navbar).addClass('open');
            $('html').addClass('disable-scroll');
        } else {
            $(this).removeClass('open');
            $(target).removeClass('show');
            $(navbar).removeClass('open');
            $('html').removeClass('disable-scroll');
        }
    });

    if (document.querySelectorAll(".hauptrunde-btn").length > 0) {
        document.querySelectorAll(".hauptrunde-btn")[0].addEventListener("click", function (event) {
            $('.hauptrunde-btn').addClass('active');
            $('.nebenrunde-btn').removeClass('active');
            $('.nebenrunde-div').addClass('hide');
            $('.hauptrunde-div').removeClass('hide');
        });
        document.querySelectorAll(".nebenrunde-btn")[0].addEventListener("click", function (event) {
            $('.hauptrunde-btn').removeClass('active');
            $('.nebenrunde-btn').addClass('active');
            $('.nebenrunde-div').removeClass('hide');
            $('.hauptrunde-div').addClass('hide');
        });
    }


    imagesLoaded(document.querySelector("body"), function (instance) {


        if (document.querySelectorAll(".gallery .glide").length > 0) {
            document.querySelectorAll(".gallery").forEach((gallery) => {
                let glide = gallery.querySelector('.glide');
                new Glide(glide, {autoplay: 5000}).mount()
            });
        }

        if (document.querySelectorAll(".text-bilder .glide").length > 0) {
            document.querySelectorAll(".text-bilder").forEach((gallery) => {
                if(gallery.querySelector('.glide')) {
                    let glide = gallery.querySelector('.glide');
                    new Glide(glide, {autoplay: 5000}).mount()
                }
            });
        }


        // fadein main

        var tlinit = gsap.timeline({
            onComplete: function () {
                //console.log('complete');
                $('.loader').hide();
                tlinit.play();
            }
        });

        tlinit.to('.loader', {
            opacity: 0,
            duration: 0.050
        }, '+=0');


        tlinit.to('.navbar', {
            opacity: 1,
            duration: 0.250
        }, '+=0');

        tlinit.to('.banner, .live-section', {
            opacity: 1,
            duration: 0.250
        }, '+=0.10');
        tlinit.to('main', {
            opacity: 1,
            duration: 0.550
        }, '+=0');

        document.querySelectorAll(".countdown-timer").forEach((elem) => {

            let end = new Date(elem.dataset.end)
            //let ts = countdown(start, end, units, max, digits);

            let interval = setInterval(function () {
                let start = new Date()
                let timerId = countdown(end, function (ts) {
                    if (end.getTime() > start.getTime()) {
                        elem.innerHTML = '<div class="d-flex"><div class="element day"><span class="number">' + ts.days + '</span><span class="name">Tage</span></div>:\n' +
                            '             <div class="element hour"><span class="number">' + ts.hours + '</span><span class="name">Stunden</span></div>:\n' +
                            '             <div class="element minute"><span class="number">' + ts.minutes + '</span><span class="name">Minuten</span></div>:\n' +
                            '             <div class="element second"><span class="number">' + ts.seconds + '</span><span class="name">Sekunden</span></div></div>';
                    } else {
                        elem.innerHTML = '<div class="d-flex"><div class="element day"><span class="number">0</span><span class="name">Tage</span></div>:\n' +
                            '             <div class="element hour"><span class="number">0</span><span class="name">Stunden</span></div>:\n' +
                            '             <div class="element minute"><span class="number">0</span><span class="name">Minuten</span></div>:\n' +
                            '             <div class="element second"><span class="number">0</span><span class="name">Sekunden</span></div></div>' + elem.dataset.etext;
                    }
                    //console.log(ts)
                }, countdown.DAYS | countdown.HOURS | countdown.MINUTES | countdown.SECONDS);

            }, 500)

            //window.clearInterval(timerId);
        })


    });


})();

// navbar shrink
window.addEventListener("scroll", function () {
    var nav = document.getElementById("mainNav");
    if (window.scrollY > 100) {
        nav.classList.add("shrink");
    } else {
        nav.classList.remove("shrink");
    }
});

